import React from 'react';
import axios from 'axios';
import moment from 'moment';
import Loading from '../components/Loading';
import { apiError } from '../utils/errors';
import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import AddEditPetForm from '../components/AddEditPetForm';
import EditUserForm from '../components/EditUserForm';
import { ConsultationHistory } from 'vetchat-react';
import VetConsultations from '../components/VetConsultations';
import { gaPageview } from '../utils/dev';

import UserSubscription from '../components/UserSubscription';

const styles = {
  dialog: {
    heading: {
      marginLeft: 25,
      marginTop: 20,
      fontWeight: 'bold'
    },
    text: {
      fontSize: 15
    },
    button: {
      fontSize: 15
    }
  }
};

// Consultation Limit for subscribed User
const subscribedConsultationsLimit = 6;

export default class MyAccount extends React.Component {
  // Constructor
  constructor(props) {
    super(props);

    // Bindings
    this.startChat = this.startChat.bind(this);
    this.setChatType = this.setChatType.bind(this);
    this.toggleLargeDialog = this.toggleLargeDialog.bind(this);
    this.savePetInfo = this.savePetInfo.bind(this);
    this.loadConsultsForVet = this.loadConsultsForVet.bind(this);
    this.changeSorting = this.changeSorting.bind(this);
    this.closeDialog = this.closeDialog.bind(this);

    // interval for reloading consultations
    this.intervalId = null;

    // Setup the state
    this.state = {
      user: {},
      pets: [],
      isLoading: true,
      dialog: false,
      error_dialog: false,
      pet_id: 0,
      pet_issue: '',
      chatType: '',
      loading_msg: 'Loading...',
      largeDialog: false,
      largeDialogContent: '',
      editPet: null,
      loadedTime: null,
      display: 'All',
      subscribedConsultations: 0
    };
  }

  /**
   * Load User's Pets
   */
  async loadPets() {
    await axios
      .get(axios.defaults.baseURL + '/pet')
      .then(response => {
        let pets = response.data.pets;

        if (pets.length === 1) {
          this.setState({ pet_id: pets[0].id });
        }

        /* const existingPets = localStorage.getItem("pets");
        if (existingPets !== null && JSON.stringify(pets) !== existingPets) {
          this.setState({ pets: pets });
          return;
        } */

        this.setState({ pets: pets });
        localStorage.setItem('pets', JSON.stringify(pets));
      })
      .catch(e => apiError(this, e));
  }

  /**
   * Load User Information
   */
  async loadUser() {
    await axios
      .get(axios.defaults.baseURL + '/user/me')
      .then(async response => {
        let user = response.data.user;

        if (user.type === 2 || user.type === 3) {
          user.consultations = await this.loadConsultsForVet();
          this.setState({ loadedTime: moment() });
        }

        localStorage.setItem('user', JSON.stringify(user));

        //countSubscribed Consultations
        let subs_consultations = user.subscription
          ? user.subscription.consultations
          : null;

        // console.log('subscription Consultations: ', subs_consultations);
        if (subs_consultations !== null) {
          subs_consultations = JSON.parse(subs_consultations);
        } else {
          subs_consultations = [];
        }

        this.setState({
          user: user,
          subscribedConsultations: subs_consultations.length
        });

        await this.loadPets();
      })
      .catch(e => apiError(this, e));
  }

  async loadConsultsForVet() {
    return await axios
      .get(axios.defaults.baseURL + '/consultation')
      .then(response => {
        if (this.intervalId === null) {
          this.intervalId = setInterval(async () => {
            // console.log("reloading content: ", moment().format("LTS"));
            let user = JSON.parse(localStorage.getItem('user'));
            user.consultations = await this.loadConsultsForVet();
            this.setState({ user: user, loadedTime: moment() });
            await this.loadPets();
          }, 30000);
        }

        return response.data.consultations;
      });
  }

  async componentDidMount() {
    document.title = 'My Account | VetChat';
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    gaPageview(this.props.location);

    // Load User, then load Pets
    await this.loadUser();

    // Once loaded set loading to false
    await this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  setChatType(type) {
    if (this.state.pets.length === 0) {
      alert('Add pet before starting a consult');
      return;
    }
    if (
      this.state.user.subscription === null ||
      this.state.subscribedConsultations >= subscribedConsultationsLimit
    ) {
      this.props.history.push(`${type}-purchase`);
    } else {
      axios
        .get(axios.defaults.baseURL + '/consultation/time')
        .then(() => {
          this.setState({ dialog: true, chatType: type });
        })
        .catch(e => {
          this.setState({ error_dialog: true });
        });
    }
  }

  async startChat() {
    if (parseInt(this.state.pet_id) === 0) {
      alert('Please select a pet');
      return;
    }

    if (this.state.pet_issue === '') {
      alert('Please provide the details of your enquiry');
      return;
    }

    this.setState({ isLoading: true });

    let chat_type = this.state.chatType === 'text' ? 1 : 2;

    await axios
      .post(axios.defaults.baseURL + '/consultation', {
        pet_id: this.state.pet_id,
        pet_issue: this.state.pet_issue,
        type: chat_type
      })
      .then(response => {
        if (response.data.errors !== undefined) {
          this.setState({ isLoading: false });
          apiError(this, response.data.errors);
          console.log(response.data.errors);
        }
        let consultation_id = response.data.consultation.id;

        //add cinsultation to subscription
        axios.post(
          axios.defaults.baseURL +
            '/user/subscriptionUsage/' +
            this.state.user.subscription.subs_id,
          { consultation: consultation_id }
        );

        //redirect user to consultation page
        this.props.history.push(
          '/' + this.state.chatType + '-chat/' + consultation_id
        );
      })
      .catch(e => {
        this.setState({ isLoading: false });
        apiError(this, e);
      });
  }

  toggleLargeDialog(content) {
    const { largeDialog } = this.state;
    if (largeDialog === true) {
      this.setState({ largeDialog: false, largeDialogContent: '' });
      if (this.state.largeDialogContent === 'addEditPet') {
        this.setState({ editPet: null });
      }
    } else {
      this.setState({ largeDialog: true, largeDialogContent: content });
    }
  }

  showLoading(title) {
    return <Loading title={title} />;
  }

  changeSorting(showType) {
    const types = ['All', 'Completed', 'In Progress', 'Available'];
    if (types.indexOf(showType) !== -1 && showType !== this.state.display) {
      this.setState({ display: showType });
    }
  }

  async savePetInfo(petInfo) {
    this.toggleLargeDialog();
    let pet_image = '';

    //upload pet image
    if (petInfo.image !== undefined) {
      await axios
        .post('/upload', petInfo.image)
        .then(res => {
          pet_image = res.data.filename;
        })
        .catch(err => {
          console.log('error uploading image');
        });
    }

    if (petInfo.pet_id === null) {
      // add new pet
      await axios
        .post('/pet', { ...petInfo, pet_image })
        .then(response => {
          // return;
          let { pets } = this.state;
          pets.push(response);
          this.setState({ pets });
        })
        .catch(err => {
          console.log('had error adding pet: ', err);
        });
    } else {
      // update pet
      const updateInfo = {
        name: petInfo.name,
        id: petInfo.pet_id,
        species_id: petInfo.pet_species,
        breed_id: petInfo.breed,
        microchip: petInfo.michrochip,
        // age: petInfo.age,
        sex: petInfo.sex,
        dob: petInfo.dob
      };

      if (pet_image !== '') {
        updateInfo['pet_image'] = pet_image;
      }
      await axios
        .post('/pet/update', updateInfo)
        .then(response => {
          // console.log(response);
          let { pets } = this.state;
          for (let pet in pets) {
            if (pets[pet].id === petInfo.pet_id) {
              pets[pet] = response.data.pet[0];
            }
          }

          this.setState({ pets });
        })
        .catch(err => {
          console.log('had error adding pet: ', err);
        });
    }
  }

  closeDialog() {
    console.log('close Dialog initialized');
    this.setState({ dialog: false });
  }

  //petstock Subscriber Validation
  isPetStockUser = () => {
    const { subs_id } = this.state.user.subscription;
    const id_split = subs_id.split('_');

    return id_split[0] === 'ps' ? true : false;
  };

  render() {
    if (this.state.isLoading) {
      return (
        <div className='container space-top space-bottom'>
          <Loading title={this.state.loading_msg} />
        </div>
      );
    }

    if (this.state.user.type === 2 || this.state.user.type === 3) {
      return (
        <VetConsultations {...this.state} changeSorting={this.changeSorting} />
      );
    }

    const mapPets = this.state.pets.map((pet, index) => {
      let petSex = 'fa fa-mars';
      if (pet.sex === 2) {
        petSex = 'fa fa-venus';
      }

      let petSpecies = 'fa fa-paw';
      if (pet.species_id === 1) {
        petSpecies = 'fa fa-dog';
      } else if (pet.species_id === 2) {
        petSpecies = 'fa fa-cat';
      }

      let pet_image = '/images/logo.png';
      if (pet.pet_image !== null && pet.pet_image !== '') {
        pet_image = axios.defaults.baseURL + '/uploads/' + pet.pet_image;
      }

      let petAge = '-';
      if (pet.dob !== null) {
        const duration = moment().diff(pet.dob, 'months', true);
        petAge = moment.duration(duration, 'months').humanize();
      }

      return (
        <div
          key={`pet-${index}`}
          className='col-sm-12'
          style={{ marginBottom: 20 }}
        >
          <div className='row pet-info'>
            <div className='col-xs-3 pet-icon text-center'>
              <div
                style={{
                  backgroundImage: `url(${pet_image})`
                }}
              ></div>
              <i
                className='fa fa-edit edit-pet'
                onClick={() => {
                  this.toggleLargeDialog('addEditPet');
                  this.setState({ editPet: pet });
                }}
              ></i>
            </div>
            <div
              className='col-xs-9 pet-detail'
              style={{ border: '1px solid #ccc', borderRadius: 5 }}
            >
              <h4 className='petName'>
                {pet.name}
                &nbsp;
                <span className={`icon-pet-sex ${petSex}`} />
                <span
                  className={`icon-pet-species ${petSpecies} pull-right fa-flip-horizontal`}
                />
              </h4>
              <div className='detail'>
                <span>Breed:</span>
                {pet.breed !== null ? pet.breed.name : ''}
              </div>
              <div className='detail'>
                <span>Age:</span>
                {petAge}
              </div>
            </div>
          </div>
        </div>
      );
    });

    const {
      dialog,
      error_dialog,
      largeDialog,
      largeDialogContent,
      editPet,
      user
    } = this.state;

    return (
      <>
        <div className='myaccount-header'>
          <div className='container'>
            <div className='row text-right'>
              <h4 className='col-sm-12'>My Vetchat Account</h4>
            </div>
          </div>
        </div>
        <div className='container'>
          {/* New Consultation Dialog */}
          <Dialog open={dialog} onClose={this.closeDialog}>
            <p style={styles.dialog.heading}>Choose Pet</p>
            <DialogContent>
              Please select your pet for {this.state.chatType} consultation
              <br /> <br />
              <select
                className='form-control'
                onChange={event =>
                  this.setState({ pet_id: event.target.value })
                }
                value={this.state.pet_id}
              >
                {this.state.pets.map(pet => (
                  <option key={pet.id} value={pet.id}>
                    {pet.name}
                  </option>
                ))}
              </select>
              <br />
              Please provide details of your enquiry below:
              <textarea
                className='form-control'
                onChange={event =>
                  this.setState({ pet_issue: event.target.value })
                }
                value={this.state.pet_issue}
              />
            </DialogContent>
            <DialogActions>
              <button
                className='btn btn-transparent'
                onClick={this.closeDialog}
              >
                Cancel
              </button>
              <button className='btn btn-success' onClick={this.startChat}>
                Start
              </button>
            </DialogActions>
          </Dialog>

          {/* Consultation Offline Dialog */}
          <Dialog open={error_dialog}>
            <p style={styles.dialog.heading}>Error</p>
            <DialogContent>
              Vetchat is currently offline (Online between 6:00am to 12:00am SYD
              Time). Please call your nearest Vet.
            </DialogContent>
            <DialogActions>
              <button
                className='btn btn-transparent'
                onClick={() => this.setState({ error_dialog: false })}
              >
                OK
              </button>
            </DialogActions>
          </Dialog>

          <div className='row'>
            <div className='col-sm-8 chat-action-btns'>
              <button
                className='btn btn-vetchat btn-consult'
                onClick={() => {
                  this.setChatType('video');
                }}
              >
                Video Now
              </button>
              <button
                className='btn btn-vetchat btn-consult'
                onClick={() => {
                  this.setChatType('text');
                }}
              >
                Chat Now
              </button>
            </div>

            <div className='col-sm-4 account-action-btns'>
              <div
                className='content-link link-chevron text-right'
                onClick={() => {
                  this.toggleLargeDialog('editUser');
                }}
              >
                Edit my account details
              </div>
              {this.state.user && this.state.user.subscription !== null && (
                <>
                  <div
                    className='content-link link-chevron text-right'
                    onClick={() => {
                      this.toggleLargeDialog('subscription');
                    }}
                  >
                    Subscription
                  </div>
                  <div
                    className='content-link link-chevron text-right'
                    onClick={() => {
                      this.props.history.push('/logout');
                    }}
                  >
                    Logout
                  </div>
                </>
              )}
            </div>
            <div className='clearfix' />
            <div className='col-sm-12'>
              <div className='row'>
                <div className='col-sm-5'>
                  <h3>My Pets</h3>
                  <hr />
                  <div className='row'>
                    {mapPets}
                    {!this.isPetStockUser() && (
                      <div className='col-xs-12'>
                        <div className='row'>
                          <div className='col-xs-9 col-xs-offset-3 add-more-pets'>
                            <button
                              className='btn-transparent btn btn-block btn-add-pet'
                              onClick={() => {
                                this.toggleLargeDialog('addEditPet');
                              }}
                            >
                              <i className='fa fa-plus' /> Add pet
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-sm-6 col-sm-offset-1'>
                  <h3>My Consultation History</h3>
                  <hr />
                  <div className='row consultation-history'>
                    <ConsultationHistory
                      showLoading={this.showLoading}
                      api={axios.defaults.baseURL}
                      axios={axios}
                      moment={moment}
                      user={this.state.user.id}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Dialog
            open={largeDialog}
            onClose={this.toggleLargeDialog}
            fullWidth={true}
            maxWidth={`lg`}
          >
            <DialogContent>
              {largeDialogContent === 'addEditPet' && (
                <AddEditPetForm
                  editPet={editPet}
                  closeDialog={this.toggleLargeDialog}
                  savePet={this.savePetInfo}
                />
              )}
              {largeDialogContent === 'editUser' && (
                <EditUserForm
                  user={user}
                  closeDialog={this.toggleLargeDialog}
                />
              )}

              {largeDialogContent === 'subscription' && (
                <UserSubscription
                  user={user}
                  closeDialog={this.toggleLargeDialog}
                  consultationLimit={subscribedConsultationsLimit}
                />
              )}
            </DialogContent>
          </Dialog>
        </div>
      </>
    );
  }
}
